import { render, staticRenderFns } from "./AdditionalCost.vue?vue&type=template&id=1f27bcda"
import script from "./AdditionalCost.vue?vue&type=script&lang=js"
export * from "./AdditionalCost.vue?vue&type=script&lang=js"
import style0 from "./AdditionalCost.vue?vue&type=style&index=0&id=1f27bcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports